import React from 'react';
import PropTypes from 'prop-types';
import { OrganizationForm, BsOrganizationForm } from 'components';


/**
 * 在這邊描述這個組件
 */

export const OrganizationEdit = props => (
  props.isAdmin ? <OrganizationForm {...props} /> : <BsOrganizationForm  {...props} />
);

OrganizationEdit.propTypes = {
  children: PropTypes.node,
  isAdmin: PropTypes.bool
};


